import React from "react";

// Ícones dos módulos de venda no cabeçalho (pedido do dono, 25/10/2026): o
// lucide não tem mesa de restaurante, caixa registradora, totem nem moto de entrega.
// Mesmo traço do lucide (24×24, stroke 2, pontas redondas) e a mesma API
// (`size`, `strokeWidth`, `className`), para trocar um pelo outro sem ajuste.
function criar(nome, desenho) {
  const Icone = React.forwardRef(function Icone({ size = 24, strokeWidth = 2, className = "", ...props }, ref) {
    return (
      <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
        className={className} aria-hidden="true" {...props}>
        {desenho}
      </svg>
    );
  });
  Icone.displayName = nome;
  return Icone;
}

/** Mesa com duas cadeiras, de lado — módulo Mesas. */
export const MesaIcon = criar("MesaIcon", (
  <>
    <path d="M6.5 10h11" />
    <path d="M12 10v10" />
    <path d="M9.5 20h5" />
    <path d="M3 4v16" />
    <path d="M3 14h3.5v6" />
    <path d="M21 4v16" />
    <path d="M21 14h-3.5v6" />
  </>
));

/** Caixa registradora (visor, teclas, gaveta) — venda no Balcão. */
export const CaixaRegistradoraIcon = criar("CaixaRegistradoraIcon", (
  <>
    <rect x="8" y="2.5" width="8" height="4.5" rx="1" />
    <path d="M12 7v2" />
    <path d="M4.5 15 6 9h12l1.5 6" />
    <path d="M9 12h.01" />
    <path d="M12 12h.01" />
    <path d="M15 12h.01" />
    <rect x="3" y="15" width="18" height="6" rx="1.5" />
    <path d="M10 18h4" />
  </>
));

/** Moto com a bag de entrega — Delivery. */
export const MotoEntregaIcon = criar("MotoEntregaIcon", (
  <>
    <rect x="2" y="4" width="8" height="7" rx="1" />
    <path d="M6 4v3" />
    <circle cx="5.5" cy="18" r="2.5" />
    <circle cx="18.5" cy="18" r="2.5" />
    <path d="M8 18h6.5l2.5-6.5" />
    <path d="M3 14h7.5l3 4" />
    <path d="M14 5h2.5l2 13" />
  </>
));

/** Totem de autoatendimento (tela, leitor de cartão, pedestal) — Totem. */
export const TotemIcon = criar("TotemIcon", (
  <>
    <rect x="6" y="2" width="12" height="14" rx="2" />
    <rect x="8.5" y="4.5" width="7" height="6" rx="0.5" />
    <path d="M10 13h4" />
    <path d="M12 16v4" />
    <path d="M8.5 21h7" />
  </>
));
